// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"76fbaed9","849":"63f32b35"}[chunkId] + ".chunk.css";
};